<template>
  <z-btn
    rounded
    :text="text"
    :icon="icon"
    :color="color"
    :primary="primary"
    :confirmation="confirmation"
    :dark="dark"
    :disabled="disabled"
    :is-loading="isLoading"
    :icon-right="iconRight"
    :large="large"
    :small="small"
    :medium="medium"
    :remove-bg="removeBg"
    @click="$emit('click')"
  ></z-btn>
</template>

<script>
/**
 * Helper para usar diretamente o botão rounded.
 * Contém exatamente o mesmo comportamento que o zBtn
 *
 * @deprecated
 */
export default {
  name: 'ZRoundedBtn',
  props: {
    /**
     * Texto do botão
     */
    text: {
      type: String,
      required: false,
    },
    /**
     * Ícone para ser usado no botão
     */
    icon: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Indicação da cor do botão
     */
    color: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Flag para indicar que é um botão primário (fica preenchido com background primário)
     */
    primary: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para indicar que é um botão de confirmação
     */
    confirmation: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o conteúdo com cor branca
     */
    dark: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para desabilitar o botão
     */
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão em modo loading
     */
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o ícone passado na direito
     */
    iconRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão grande (default no mobile)
     */
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão pequeno
     */
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Flag para deixar o botão medio (default no desktop)
     */
    medium: {
      type: Boolean,
      required: false,
      default: false,
    },
    /**
     * Remove o background do botão (text)
     */
    removeBg: {
      type: Boolean,
      required: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-rounded-btn-text {
  margin-right: 8px;
  margin-left: 8px;
}
</style>
